<template>
  <footer :class="['relative text-gray-300', footerTransparent || 'bg-[#0d1117]']" role="contentinfo">
    <IframeRemoteFooter :autoHeight="true" class="remote-footer-container" />
    <div class="sr-only" aria-live="polite">Footer remoto caricato via iframe</div>
  </footer>
</template>

<script>
import IframeRemoteFooter from './IframeRemoteFooter.vue';
export default {
  name: 'FooterApp',
  components: { IframeRemoteFooter },
  props: {
    footerTransparent: { type: String, default: '' },
    // Non più necessario passare URL: il componente iframe ha fallback fisso.
  }
};
</script>

<style scoped>
.sr-only{ position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; border:0; }
</style>